import { SerializedConstructor } from '@langchain/core/load/serializable';

import { RunSchema } from '@/types/schema';

import { PlaygroundPromptInputs } from '../PlaygroundPrompt/PlaygroundPrompt';
import { PlaygroundSectionHeader } from './PlaygroundSectionHeader';
import { usePlaygroundStore } from './hooks/usePlaygroundStore';

export function PromptInputSection({
  input,
  manifests,
}: {
  input: RunSchema['inputs'];
  manifests: SerializedConstructor[];
}) {
  const inputSourceType = usePlaygroundStore((state) => state.inputSourceType);

  return (
    <div className="flex h-full flex-col">
      <div className="flex-shrink-0">
        <PlaygroundSectionHeader
          title="Inputs"
          tooltipDescription="Enter variable values for your prompt. You can input them manually or test multiple values through the 'Set up Evaluation' option."
        />
      </div>
      <div className="mx-6 my-2 flex-1 overflow-y-auto">
        {inputSourceType === 'manual' && (
          <PlaygroundPromptInputs input={input} manifests={manifests} />
        )}
      </div>
    </div>
  );
}
